<template>

	<div>
		
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
		<Hero :slides="hero.slides" :smallHero="hero.smallHero"></Hero>
		
        <section class="news-article-page">
            <div class="container">
                <Breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></Breadcrumbs>
                <div class="article-header row">
                    <div class="col-lg-6">
                        <div class="video-wrapper">
                            <iframe src="https://www.youtube.com/embed/qK8VPXi2AsE"></iframe>
                        </div>
                    </div>
                    <div class="col-lg-6 headline-media">
                        <div class="headline">
                            <h1>Video Article Title</h1>
                            <span>April 11, 2019</span>
                        </div>
                    </div>
                </div>
                <div class="article-header row">
                    <div class="col-lg-6">
                        <div class="img-wrapper">
                            <img src="https://picsum.photos/500/300?random" alt="Alternate Text" />
                        </div>
                    </div>
                    <div class="col-lg-6 headline-media">
                        <div class="headline">
                            <h1>Image Article Title</h1>
                            <span>April 11, 2019</span>
                        </div>
                    </div>
                </div>
                <div class="article-header row">
                    <div class="col-sm-12">
                        <div class="headline">
                            <h1>Regular Article Title</h1>
                            <span>April 11, 2019</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 sidebar">
                        <div class="share">
                            <h4>Share this story</h4>
                            <div class="share-icons">
                                <div class="sharethis-inline-share-buttons"></div>
                            </div>
                        </div>
                        <div class="featured-article" :key="item.id" v-for="item in relatedArticles.featured">
                            <NewsItem :newsItem="item" :layout="'tall'"></NewsItem>
                        </div>
                        <div class="basic-callout">
                            <div class="title-img">
                                <img src="https://picsum.photos/500/300?15" alt="Alternate Text" />
                                <div class="overlay">
                                    <a href="#">Link number 1</a>
                                </div>
                            </div>
                            <div class="callout-text">
                                <h3 class="title">
                                    This is the title for a callout
                                </h3>
                                <p class="detail">
                                    This is more detailed text.  It could be several sentences and go on for awhile.
                                </p>
                                <a class="cta-primary" href="#">
                                    Link number 2
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="main col-lg-8">
                        <div class="detail-section">
                            <h5 class="intro-text">Intro Text</h5>
                            <p>
                                Quick win emoji run whistler smart alexa gif okemo works on my local internet outage audit laptop Boston. App zuma data run laptop rock & roll quick wins nerf war out of scope fireside chat run out of scope. Drive Boston the nest creative Robin Reviews super simple quick wins hotlist accountability frontier. Motown quick win ping pong dragons New York integrity migration. La Croix Visual Studio solutions hyde focus beer mos eisley global serves serve quick win agile solutions. The cliffs hyde global wi-fi platforms whistler Atlanta. Board games sipping time La Croix design zune akward teenage stage serve agency of the future the dungeon integrity engineering serve Dallas. Science fair whistler ping pong frontier. Cold brew abbey road integrity nerf war. Skype serves crawl Atlanta Denver rubber duck Episerver flash Skype low hanging fruit el porto.
                            </p>
                            <img src="https://picsum.photos/600/400?12" alt="Alternate Text" />
                            <p>
                                Lift and shift learning laptop copper sarvis. Work Denver pretzels hunky dory fox La Croix analytics. The cliffs design shopping digital rainbows gather inspire Jaipur insight matrix brand. Episerver parter Sharepoint zuma inspire experts audit the lair are you on mute san onofre brand. The port ping pong Los Angeles testing loon Teams hunky dory brand cheese and whine the lair stowe Sharepoint hardware. Tubing experts lift and shift starfish collaboration technology profitability mobile bowling in the work network. Meenie shopping collaboration stowe Slack gif people Coca-Cola. War room cathedral baywatch out of scope city palace the blindside innovation mvp emoji hoteling passion ping pong coffee. You're not sharing your screen super simple tubing alexa fireside chat network pourcast focus. Zuma laptop analytics virtual board games.
                            </p>
                            <p>
                                Alexa intrapreneurship moe expertise crawl drive engineering zune New York sarvis crawl san onofre. Starfish creative the nest Skype digital mos eisley engineering pride beer platforms virtual pizza. Episerver work cloud in the work lift and shift miney Boston platforms punchline whistler. Digital Starbucks interface need moar coffee matrix meenie. Content wi-fi Oakland wi-fi i-frame management. Thread bowling are you on mute amer mvp content motown organization dragons desktop fox hawa mahal. Management internet outage hunky dory Atlanta mobile audit accountability board games stranger things walk. Pretzels Coca-Cola insight sarves expertise Los Angeles ping pong. Productivity shopping hardware lord of the mini coop app laptop emoji lord of the mini coop. Studio one Boston crawl digital beer fox stowe ctrl alt delete sunapee Starbucks.
                            </p>
                            <blockquote>
                                Excellence powershell all the things wi-fi hawa mahal the lair. The blindside run dukes of hazard meetings productivity Raizlabs Sitecore.
                            </blockquote>
                            <p>
                                Quick win emoji run whistler smart alexa gif okemo works on my local internet outage audit laptop Boston. App zuma data run laptop rock & roll quick wins nerf war out of scope fireside chat run out of scope. Drive Boston the nest creative Robin Reviews super simple quick wins hotlist accountability frontier. Motown quick win ping pong dragons New York integrity migration. La Croix Visual Studio solutions hyde focus beer mos eisley global serves serve quick win agile solutions. The cliffs hyde global wi-fi platforms whistler Atlanta. Board games sipping time La Croix design zune akward teenage stage serve agency of the future the dungeon integrity engineering serve Dallas. Science fair whistler ping pong frontier. Cold brew abbey road integrity nerf war. Skype serves crawl Atlanta Denver rubber duck Episerver flash Skype low hanging fruit el porto.
                            </p>
                            <p>
                                Lift and shift learning laptop copper sarvis. Work Denver pretzels hunky dory fox La Croix analytics. The cliffs design shopping digital rainbows gather inspire Jaipur insight matrix brand. Episerver parter Sharepoint zuma inspire experts audit the lair are you on mute san onofre brand. The port ping pong Los Angeles testing loon Teams hunky dory brand cheese and whine the lair stowe Sharepoint hardware. Tubing experts lift and shift starfish collaboration technology profitability mobile bowling in the work network. Meenie shopping collaboration stowe Slack gif people Coca-Cola. War room cathedral baywatch out of scope city palace the blindside innovation mvp emoji hoteling passion ping pong coffee. You're not sharing your screen super simple tubing alexa fireside chat network pourcast focus. Zuma laptop analytics virtual board games.
                            </p>
                            <p>
                                Alexa intrapreneurship moe expertise crawl drive engineering zune New York sarvis crawl san onofre. Starfish creative the nest Skype digital mos eisley engineering pride beer platforms virtual pizza. Episerver work cloud in the work lift and shift miney Boston platforms punchline whistler. Digital Starbucks interface need moar coffee matrix meenie. Content wi-fi Oakland wi-fi i-frame management. Thread bowling are you on mute amer mvp content motown organization dragons desktop fox hawa mahal. Management internet outage hunky dory Atlanta mobile audit accountability board games stranger things walk. Pretzels Coca-Cola insight sarves expertise Los Angeles ping pong. Productivity shopping hardware lord of the mini coop app laptop emoji lord of the mini coop. Studio one Boston crawl digital beer fox stowe ctrl alt delete sunapee Starbucks.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <News :subtitle="relatedArticles.subtitle" :title="relatedArticles.title" :fullWidthNewsItems="relatedArticles.fullWidthNewsItems" :halfWidthNewsItems="relatedArticles.halfWidthNewsItems" :miniNewsItems="relatedArticles.miniNewsItems" :cta="relatedArticles.cta"></News>
        </section>
		
		<SocialCarousel :subtitle="socialCarousel.subtitle" :title="socialCarousel.title" :socialItems="socialCarousel.socialItems"></SocialCarousel>
		<NewsletterSignup  :subtitle="newsletterSignup.subtitle" :title="newsletterSignup.title" :body="newsletterSignup.body" :submit="newsletterSignup.submit" :forms="newsletterSignup.forms"></NewsletterSignup>
		<Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>
	
	</div>
	
</template>

<script>
	
	import Header from '../components/Header/Header.vue';
	import Hero from '../components/Hero/Hero.vue';
	import Breadcrumbs from '../components/Global/Breadcrumbs.vue';
	import NewsItem from '../components/News/NewsItem.vue';
	import News from '../components/News/News.vue';
	import SocialCarousel from '../components/Social/SocialCarousel.vue';
	import NewsletterSignup from '../components/News/NewsletterSignup.vue';
	import Footer from '../components/Footer/Footer.vue';
	import axios from 'axios';

	export default {
		name: 'NewsArticle',
		
		components: {
			Header,
			Hero,
			Breadcrumbs,
            NewsItem,
			SocialCarousel,
			NewsletterSignup,
            Footer,
            News
		},
		
		data() {
			return {
                breadcrumbs: [],
                relatedArticles: [],
                newsItems: [],
				cta: {},
				
				header: {
					utilityNav: {},
					siteNavigation: {}
				},
				hero: {
					slides: [],
					smallHero: {}
				},
				socialCarousel: {
					subtitle: "",
					title: "",
					socialItems: []
				},
				newsletterSignup: {
					subtitle: "",
					title: "",
					body: "",
					submit: "",
					forms: []
				},
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
            /* eslint-disable no-console */
			let self = this;
			
			let header = 'SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let hero = 'SampleData/HeroData.json';
			axios.get(hero).then(function(response) {
				
				self.hero.slides = response.data.slides;
				self.hero.smallHero = response.data.smallHero;
			})
			.catch(function (error) {
				console.log(error);
			});
			
            let endpointID = this.$el.parentElement.getAttribute('data-endpoint-id');
            if (endpointID) {

                let endpoint = 'SampleData/' + endpointID + '.json';

                axios.get(endpoint).then(function (response) {

                    self.breadcrumbs = response.data.breadcrumbs;
                    self.relatedArticles = response.data.relatedArticles;
                    self.newsItems = response.data.relatedArticles.newsItems;
                    self.cta = response.data.relatedArticles.cta;
                })
				.catch(function (error) {
					console.log(error);
				});
            }
			
			let socialCarousel = 'SampleData/SocialCarouselData.json';
			axios.get(socialCarousel).then(function(response) {
				
				self.socialCarousel.title = response.data.title;
				self.socialCarousel.subtitle = response.data.subtitle;
				self.socialCarousel.socialItems = response.data.socialItems;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let newsletterSignup = 'SampleData/NewsletterSignupData.json';
			axios.get(newsletterSignup).then(function(response) {
				
				self.newsletterSignup.title = response.data.title;
				self.newsletterSignup.subtitle = response.data.subtitle;
				self.newsletterSignup.title = response.data.title;
				self.newsletterSignup.body = response.data.body;
				self.newsletterSignup.submit = response.data.submit;
				self.newsletterSignup.forms = response.data.forms;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let footer = 'SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>